export const extensionRoutes = [  {
    path: 'extensions/visitas',
    loadChildren: () => import('./extensions/64ee2f4a3880d73de42431ffe89a3ca2d5fdeb17326191b830f99d436d2722b9/ui-lazy.module').then(m => m.UiLazyModule),
  }];
